module.exports = __webpack_public_path__ + "media/interested_companies/images/bell-ab14faa4429e573e4f92fa6e01894306.svg";